import { Card, CoherenceDataGrid } from "@coherence-design-system/controls";
import React, { useContext, useEffect, useState } from "react";
import * as H from "history";
import { CustomerAccountService } from "../../services/Accounts/CustomerAccountService";
import {
  ActionButton,
  IIconProps,
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  Separator,
  Spinner,
  SpinnerSize,
  Stack,
} from "@fluentui/react";
import { Customer } from "./Customer";
import "./CustomerAccountStyle.css";
import { useLocalStorageContext } from "../../Provider/LocalStorageProvider";
import { CustomerAccountStakStyle} from "./CustomerStyle";

interface IAccountsProps {
  //history?: H.History;
  onCustomerAccount: (isCustomerAccount: boolean) => void;
}

export const CustomerAccount: React.FunctionComponent<IAccountsProps> = (
  props
) => {
  const stackTokens = { childrenGap: 10 };
  const customerHeading = "Customers";
  const [isLoading, setIsLoading] = useState(true);
  // const { userWithNoRole, userCountry, userRegion } = useContext(LocalStorageContext);
  const { userRegions, userRole } = useLocalStorageContext();

  const CardStyles = {
    layout: {
      margin: 0,
      padding: 0,
      paddingLeft: "30px"
    },
    root:{
      overflowX: "auto"
    }
  };
  // const userRegions = userRegion ? JSON.parse(userRegion) : undefined;

  // useEffect(() => {
  //   props.onCustomerAccount(true);
  //   if(userCountry || userRegion || userWithNoRole === "NoRole"){
  //     setIsLoading(false)
  //   }
  // }, [userCountry, userRegion, userWithNoRole]);
  useEffect(() => {
    props.onCustomerAccount(true);
    if (userRole || userRegions) {
      setIsLoading(false);
    }
  }, [userRole, userRegions]);

  if (isLoading) {
    return <Spinner size={SpinnerSize.large} />;
  }

  return (
    <Stack
    styles={CustomerAccountStakStyle}
    >
      <Card styles={CardStyles}><h2>{customerHeading}</h2></Card> 
      <Stack>
        <Pivot
          aria-label="All"
          styles={{ root: { marginLeft: "25px" } }}
        >
          <PivotItem headerText="All">
            <Customer
              region="ALL"
              searchRegion={
                userRegions?.length > 0
                  ? userRegions
                  : ["EMEA", "APAC", "China", "Japan"]
              }
            />
          </PivotItem>
          {userRegions?.map((region: any) => (
            <PivotItem key={region} headerText={region}>
              <Customer region={region} searchRegion={[]} />
            </PivotItem>
          ))}
        </Pivot>
      </Stack>
    </Stack>
  );
};
